import React from "react";
import DataTablePage, { StatusBadge, formatDate } from "./DataTablePage";

const priMap = {
  critical: { v: "critical", label: "Critical" },
  high: { v: "warning", label: "High" },
  medium: { v: "warning", label: "Medium" },
  low: { v: "success", label: "Low" },
};
const statusMap = {
  todo: { v: "neutral", label: "To do" },
  in_progress: { v: "info", label: "In progress" },
  done: { v: "success", label: "Done" },
};

export default function TasksPage() {
  return (
    <DataTablePage
      title="My Tasks"
      description="Compliance and remediation tasks assigned across the organisation."
      endpoint="/tasks"
      testIdPrefix="tasks"
      searchKeys={["title"]}
      filters={[
        {
          key: "status",
          label: "All statuses",
          options: [
            { label: "To do", value: "todo" },
            { label: "In progress", value: "in_progress" },
            { label: "Done", value: "done" },
          ],
        },
        {
          key: "priority",
          label: "All priorities",
          options: [
            { label: "Critical", value: "critical" },
            { label: "High", value: "high" },
            { label: "Medium", value: "medium" },
            { label: "Low", value: "low" },
          ],
        },
      ]}
      columns={[
        { key: "title", label: "Task" },
        { key: "priority", label: "Priority", render: (r) => <StatusBadge value={r.priority} map={priMap} /> },
        { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} map={statusMap} /> },
        { key: "due_date", label: "Due", render: (r) => formatDate(r.due_date) },
      ]}
    />
  );
}
